import Session from '@/utils/Session'
import Toast from '@/utils/toast'
import {getBannerList} from '@/api/basisPlatform/home.js'
import * as noticeApi from '@/api/base/notice'
import * as settingApi from '@/api/base/setting'

export const baseInfo = {
  namespaced: true,
  state: {
    bannerList: [],
    skeletonOpt: {
      banner: true,
      cardListSkeletonLoading: true
    },
    noticeInfo: {
      title: '',
      content: ''
    }
  },
  getters: {},
  mutations: {
    setBannerList(state,bannerList) {
      state.bannerList = bannerList
    },
    setSkeletonOptBanner(state,bool){
      state.skeletonOpt.banner = bool;
    },
    setCardListSkeletonLoading(state,bool){
      state.skeletonOpt.cardListSkeletonLoading = bool;
    },
    setNotice(state,noticeInfo){
      state.noticeInfo = noticeInfo || {};
    },
  },
  actions: {
    getBannerList(context) {
      let purpose = 1
      getBannerList(purpose).then(data => {
        context.commit('setBannerList',data);
        context.commit('setSkeletonOptBanner',true);
        // this.bannerList = data;
        // this.skeletonOpt.banner = true;
      }).finally(() => {
        context.commit('setSkeletonOptBanner',false);
        // this.skeletonOpt.banner = false;
      })
    },
    getNotice(context) {
      context.commit('setCardListSkeletonLoading',true);
      noticeApi.getNoticeList().then(resp => {
        console.log('获取公告', resp)
        if (resp.data.length > 0) {
          context.commit('setNotice',resp.data[0]);
        }
      }).finally(() => {
        context.commit('setCardListSkeletonLoading',false);
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/baseInfo.js